import { render, staticRenderFns } from "./manage-user.vue?vue&type=template&id=4d960550"
import script from "./manage-user.vue?vue&type=script&lang=js"
export * from "./manage-user.vue?vue&type=script&lang=js"
import style0 from "./manage-user.vue?vue&type=style&index=0&id=4d960550&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports